import React, { useEffect, useState } from "react";
import { Button, ButtonIcon, Icon } from "pepsico-ds";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import './Cards.scss'
import { useToast } from "../Toast/ToastContext";
import Vector from "../../../src/assets/Vector.png";
import { localStoreKeys } from "../../constants/localStoreKeys";
import { generatePath } from 'react-router-dom';

function getSourceBadgeColorClass(source = "") {
    const normalizedSource = (source || "").toLowerCase();
    if (normalizedSource.includes("smartcube")) return "news-source-badge-purple";
    if (normalizedSource.includes("fastmarkets") || normalizedSource.includes("risi")) return "news-source-badge-orange";
    return "news-source-badge-gray";
}

function SourceBadge({ text }) {
    if (!text) return null;
    return (
        <span className={`news-source-badge ${getSourceBadgeColorClass(text)}`}>
            {text}
        </span>
    );
}

function NewsCard({ card=null, bookmark, currentFilters, onShare }) {
    const navigate = useNavigate();
	const dispatch = useDispatch();
	const [currentCard, setCurrentCard] = useState(card);
    const newsArticleBookmarkCount = useSelector((state) => state?.localData?.data[localStoreKeys.newsArticleBookmarkCount]);
    const maxAllowedBookmarks = useSelector((state) => state?.localData?.data[localStoreKeys.maxAllowedBookmarks]);
    const { showToast } = useToast();
    function decodeEntities(str = "") {
        const doc = new DOMParser().parseFromString(str, "text/html");
        return doc.documentElement.textContent;
    }
    useEffect(() => {
        setCurrentCard(card)
    }, [card])
    /* istanbul ignore next */
    return (
		<>
            <div className="news-preview-container">
                <div className="news-preview-body">
                    <div className="news-app-source">
                        <div className="news-preview-header">{decodeEntities(currentCard?.title) || ""}</div>
                        <div>  
                            <ButtonIcon
                                aria-label="news-share-button-icon"
                                data-fs="news-share-button-icon"
                                className=""
                                icon="share"
                                label="Share"
                                onClick={function C$e(){
                                    if (typeof onShare === 'function') {
                                        onShare(currentCard);
                                    }
                                }}
                                size="large"
                                type="naked"
                                style={{ marginRight: "8px" }}
                            />
                            <ButtonIcon
                                className=""
                                icon={currentCard?.isBookmarked?"bookmark":"bookmark_border"}
                                label="Bookmark"
                                onClick={function C$e(){
                                    const bookmarkValue = !currentCard?.isBookmarked;
                                    
                                    if(newsArticleBookmarkCount>=maxAllowedBookmarks && bookmarkValue) { 
                                        
                                        showToast('warning', "You are allowed to bookmark upto "+maxAllowedBookmarks+" articles", {
                                            icon: <Icon alt="" icon="warning_amber" size="medium" />
                                        });
                                        return;
                                    }
                                    const updatedCard = 
                                    {
                                        ...card,
                                        isBookmarked:bookmarkValue
                                    }
                                    setCurrentCard(updatedCard)
                                    bookmark(updatedCard)
                                }}
                                size="large"
                                type="naked"
                            />
                        </div>
                    </div>
                    <div className="news-preview-timestamp">{currentCard?.time}</div>
                    <div className="news-app-source-meta">
                        <SourceBadge text={currentCard?.source} />
                        {currentCard?.tags?.length > 0 &&
                            <span className="news-source-tags-text">
                                {currentCard.tags.map((tag, index) => (
                                    <React.Fragment key={`${tag.key}-${index}`}>
                                        {index > 0 && " | "}
                                        <span className="news-tag-key">{(tag.key || "").toUpperCase()}</span>: {tag.value}
                                    </React.Fragment>
                                ))}
                            </span>
                        }
                    </div>
                    { currentCard?.preview && <div className="news-preview-content">{decodeEntities(currentCard?.preview) || ""}</div> }

                </div>
                <div className="news-preview-footer">
                    <Button
                        className=""
                        iconTrailing={"arrow_forward"}
                        size="medium"
                        style={{color:"#034895"}}
                        text="Read full article"
                        variant="tertiary"
                        onClick={function clickButton() {
                            if(currentCard?.link) {
                                window.open(currentCard?.link, "_blank", "noopener")

                            } else {
                                navigate("/overview/news/news-detail/"+currentCard?.id, { state: { currentFilters } });
                            }

                        }}
                    />
                    
                </div>

            </div>
        
        
        </>
    );

}

export default NewsCard;    